// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderDetailsButtonSetStyles } from "@awc/Overrides/Widgets/OrderDetails/OrderDetailsButtonSet";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

orderDetailsButtonSetStyles.printButton = {
    variant: "primary",
};

orderDetailsButtonSetStyles.shareEntityButtonStyles = {
    button: {
        variant: "primary",
    },
};

orderDetailsButtonSetStyles.reorderButton = {
    variant: "secondary",
};

orderDetailsButtonSetStyles.rmaButton = {
    variant: "primary",
};

orderDetailsButtonSetStyles.cancelButton = {
    variant: "secondary",
};

orderDetailsButtonSetStyles.spinner = {
    size: 22,
    css: css`
        margin: 8px;
    `,
};

orderDetailsButtonSetStyles.buttonsWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 16px;
        justify-content: end;
        margin-bottom: 10px;
        ${xScreen("lte", "sm")} {
            flex-direction: column;
            & > div button {
                width: 100%;
            }
        }
    `,
};

orderDetailsButtonSetStyles.buttonWrapper = {
    css: css`
        margin: 0;
        display: flex;
        justify-content: center;
    `,
};

orderDetailsButtonSetStyles.toasterMessage = {
    css: css`
        display: flex;
        align-items: center;
        a span {
            font-size: ${fontConfig.fontSize.regular}px;
        }
    `,
};

orderDetailsButtonSetStyles.twoButtonModalStyles = {};
